import React from 'react';
import { SxProps, TextField, Theme } from '@mui/material';

import { withKey } from '@paragon/client-tools';

function parseDateValue(value: string | null | undefined) {
  if (value != null && !Number.isNaN(Date.parse(value))) {
    // FIXME This is prone to time-zone issues, since dates will be interpreted in the user's local time zone and later
    //  converted to UTC.
    return new Date(value);
  }

  return null;
}

function formatDateString(date: Date | null) {
  return date ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}` : null;
}

interface Props {
  readonly sx: SxProps<Theme>;
  readonly value: string | undefined;
  readonly onChange: (date: Date) => void;
}

interface State {
  readonly dateStr: string | null;
}

class DateTextbox extends React.Component<Props, State> {
  state: State = {
    dateStr: this.buildDateStringFromProps(),
  };

  onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> = ({ target: { value } }) => {
    this.setState({ dateStr: value });
  };

  onBlur = () => {
    const parsedDate = parseDateValue(this.state.dateStr);
    if (!parsedDate) {
      this.setState({ dateStr: this.buildDateStringFromProps() });
      return;
    }

    const formattedDate = formatDateString(parsedDate);
    if (formattedDate !== this.state.dateStr) {
      this.setState({ dateStr: formattedDate });
    }

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(parsedDate);
    }
  };

  buildDateStringFromProps() {
    return formatDateString(parseDateValue(this.props.value)) ?? '';
  }

  reset() {
    this.setState({
      dateStr: '',
    });
  }

  render() {
    return (
      <TextField
        variant="standard"
        id="date"
        label="Expiration Date"
        onChange={this.onChange}
        onBlur={this.onBlur}
        value={this.state.dateStr}
        sx={this.props.sx}
      />
    );
  }
}

export default withKey('value', DateTextbox);
